const skillData = [
  {
    id: 1,
    category: "design",
    name: "Figma",
    image: "figma.png",
    level: 70,
    features: ["기본툴 인지", "다양한 작업 가능"],
  },
  {
    id: 2,
    category: "design",
    name: "Photoshop",
    image: "photoshop.png",
    level: 70,
    features: ["50GB Bandwidth", "Business & Finance Analysis"],
  },
  {
    id: 3,
    category: "design",
    name: "Illustrator",
    image: "illustrator.png",
    level: 90,
    features: ["50GB Bandwidth", "Customer Management"],
  },
  {
    id: 4,
    category: "design",
    name: "Premiere Pro",
    image: "premiere.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 5,
    category: "design",
    name: "Zeplin",
    image: "zeplin.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 6,
    category: "others",
    name: "Jira",
    image: "jira.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 7,
    category: "dev",
    name: "Visual Studio",
    image: "visualstudio.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 8,
    category: "dev",
    name: "Intelij",
    image: "intelij.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 9,
    category: "dev",
    name: "Git",
    image: "git.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 10,
    category: "dev",
    name: "React",
    image: "React.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 11,
    category: "dev",
    name: "React Native",
    image: "reactnative.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 12,
    category: "dev",
    name: "Bitbucket",
    image: "bitbucket.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 13,
    category: "dev",
    name: "Firebase",
    image: "firebase.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 14,
    category: "design",
    name: "Procreate",
    image: "procreate.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 15,
    category: "dev",
    name: "Expo",
    image: "expo.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  {
    id: 16,
    category: "others",
    name: "Notion",
    image: "notion.png",
    level: 99,
    features: ["24-hour Support", "Customer Management"],
  },
  // 추가 기능 데이터를 필요한 만큼 추가할 수 있습니다.
];

export default skillData;
